export const volumes = [
  {
    numeral: 'I',
    title: 'Why does my child go from fine to overwhelmed?',
    intro: 'I created this volume to help you recognize what may be happening before, during and after difficult moments.',
    listLabel: "I'll walk you through:",
    items: [
      'Early warning signs',
      'Changes in behavior',
      'Environmental factors',
      'Sensory factors',
      'Transitions',
      'Recurring situations',
      'What happens immediately before a meltdown',
      'What happens afterward',
    ],
    flow: [] as string[],
    note: "My goal isn't to diagnose your child. My goal is to help you observe more clearly.",
    featured: false,
  },
  {
    numeral: 'II',
    title: 'The Calm Response 5™ Method',
    intro: 'This is the heart of the system I created. I’ll walk you through my five steps:',
    listLabel: '',
    items: [
      'Pause — slow down before reacting',
      'Observe — look at what is actually happening',
      'Reduce — unnecessary stimulation, demands or environmental factors',
      'Regulate — choose an appropriate supportive strategy',
      'Recover — allow time and space to return to routine',
    ],
    flow: [] as string[],
    note: "I'll turn the entire process into simple visual frameworks you can remember.",
    featured: true,
  },
  {
    numeral: 'III',
    title: 'My SOS Meltdown Guide',
    intro: '“Okay, Laura… but what do I actually do when the meltdown is already happening?” That’s exactly why I created this volume.',
    listLabel: "I'll give you practical response protocols for situations such as:",
    items: [
      'Sensory overload',
      'Intense frustration',
      'Unexpected changes',
      'Difficult transitions',
      'Leaving the house',
      'Returning home',
      'Bedtime struggles',
      'Busy environments',
      'Emotional overwhelm',
    ],
    flow: ['What you may notice', 'What to check', 'What you can try', 'What to avoid', 'What to watch for next'],
    note: "So you don't have to start from zero every time.",
    featured: false,
  },
  {
    numeral: 'IV',
    title: 'The Calm Home Blueprint™',
    intro: "I've learned that sometimes the environment itself can add unnecessary stress. So I created this guide to help you look at your home differently.",
    listLabel: "I'll take you through:",
    items: ['Bedroom', 'Living room', 'Homework area', 'Lighting', 'Noise', 'Visual clutter', 'Routines', 'Transitions', 'Calm spaces'],
    flow: [] as string[],
    note: "You don't need to completely redesign your home. I'll show you how to look for small changes that may create more predictability.",
    featured: false,
  },
  {
    numeral: 'V',
    title: 'The Transition & Routine Toolkit™',
    intro: "I've included this because transitions are one of the moments many families struggle with most.",
    listLabel: "I'll give you visual routines for:",
    items: [
      'Mornings',
      'School preparation',
      'Coming home',
      'Meals',
      'Bath time',
      'Bedtime',
      'Changing activities',
      'Weekends',
      'Unexpected schedule changes',
    ],
    flow: [] as string[],
    note: 'The goal is simple: make the next step easier to understand.',
    featured: false,
  },
  {
    numeral: 'VI',
    title: 'Your Personal Calm Plan™',
    intro: "I don't want you using generic advice forever. I want you to build something around your child.",
    listLabel: "I'll help you document:",
    items: [
      'Early warning signs',
      'Common situations',
      'Environmental factors',
      'Recurring triggers',
      "Strategies you've tried",
      'Strategies that seemed helpful',
      "Strategies that didn't help",
      'Routines',
      'Transition challenges',
      'Helpful observations',
      "People involved in your child's care",
    ],
    flow: [] as string[],
    note: "By the end, you'll have your own Personal Calm Plan™ — a simple document you can keep updating as you learn more about your child's individual patterns.",
    featured: false,
  },
];
